/** ExecutionHubRoute — skin-aware switcher for /execution. */
import { useUISkin } from "@/data/UISkinContext";
import ExecutionHub from "./ExecutionHub";
import ExecutionDomainLanding from "./execution/ExecutionDomainLanding";

export default function ExecutionHubRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ExecutionDomainLanding />;
  return <ExecutionHub />;
}
